export default __webpack_public_path__ + "static/media/polo-salute.756d9779.png";